export const laMesaCoords_path = [
  { lat: 32.6593319, lng: -117.0759366 },
  { lat: 32.6688354, lng: -117.0423681 },
  { lat: 32.6896418, lng: -117.0173055 },
  { lat: 32.7031477, lng: -117.0109517 },
  { lat: 32.7317442, lng: -117.0161015 },
  { lat: 32.7453171, lng: -117.020908 },
  { lat: 32.7531134, lng: -117.010265 },
  { lat: 32.7597541, lng: -117.0023686 },
  { lat: 32.7788073, lng: -117.0058018 },
  { lat: 32.7915072, lng: -117.0058018 },
  { lat: 32.8200753, lng: -117.0013386 },
  { lat: 32.8350771, lng: -117.0040852 },
  { lat: 32.8373849, lng: -117.021938 },
  { lat: 32.8500764, lng: -117.0318944 },
  { lat: 32.8549795, lng: -117.0627934 },
  { lat: 32.8460384, lng: -117.0785863 },
  { lat: 32.8405579, lng: -117.0967824 },
  { lat: 32.8405579, lng: -117.1204716 },
  { lat: 32.8246915, lng: -117.1166951 },
  { lat: 32.8033396, lng: -117.1105153 },
  { lat: 32.788621, lng: -117.1156651 },
  { lat: 32.7788073, lng: -117.1132619 },
  { lat: 32.7652395, lng: -117.1318013 },
  { lat: 32.7467609, lng: -117.119785 },
  { lat: 32.7352098, lng: -117.1118886 },
  { lat: 32.7263089, lng: -117.1037811 },
  { lat: 32.7170139, lng: -117.1019322 },
  { lat: 32.7005476, lng: -117.0940358 },
  { lat: 32.6913021, lng: -117.0950658 },
  { lat: 32.6797438, lng: -117.0847661 },
  { lat: 32.6593319, lng: -117.0759366 },
];

export const powayCoords_path = [
  { lat: 32.8775599, lng: -117.1771984 },
  { lat: 32.9012001, lng: -117.114027 },
  { lat: 32.8533533, lng: -117.1040928 },
  { lat: 32.8657513, lng: -117.0462653 },
  { lat: 32.8875084, lng: -116.9788854 },
  { lat: 32.9115768, lng: -116.9499187 },
  { lat: 33.0388796, lng: -116.9883708 },
  { lat: 33.0584483, lng: -117.0371227 },
  { lat: 33.0524006, lng: -117.0642356 },
  { lat: 33.0256394, lng: -117.0796947 },
  { lat: 33.024488, lng: -117.1435527 },
  { lat: 33.0406064, lng: -117.2486095 },
  { lat: 32.8775599, lng: -117.1771984 },
];

export const carlsbadCoords_path = [
  { lat: 33.229202, lng: -117.4120311 },
  { lat: 33.0601748, lng: -117.3440532 },
  { lat: 33.0388796, lng: -117.2273235 },
  { lat: 33.1027497, lng: -117.2403698 },
  { lat: 33.1682978, lng: -117.2163372 },
  { lat: 33.2286277, lng: -117.2197704 },
  { lat: 33.252748, lng: -117.2520427 },
  { lat: 33.2234581, lng: -117.3481731 },
  { lat: 33.229202, lng: -117.4120311 },
];

export const sanDiegoCoords_path = [
  { lat: 32.8953597, lng: -117.1124647 },
  { lat: 32.8965128, lng: -117.1303176 },
  { lat: 32.8815213, lng: -117.1577837 },
  { lat: 32.8712588, lng: -117.228765 },
  { lat: 32.8711411, lng: -117.2546013 },
  { lat: 32.8711412, lng: -117.2992335 },
  { lat: 32.5483638, lng: -117.2592142 },
  { lat: 32.5379445, lng: -117.1266926 },
  { lat: 32.5453812, lng: -117.0401245 },
  { lat: 32.5522381, lng: -117.0407626 },
  { lat: 32.5707495, lng: -117.0377383 },
  { lat: 32.6366917, lng: -117.0454685 },
  { lat: 32.6609673, lng: -117.0760705 },
  { lat: 32.7097263, lng: -117.0968984 },
  { lat: 32.7401301, lng: -117.113837 },
  { lat: 32.7508237, lng: -117.1088795 },
  { lat: 32.7974496, lng: -117.1122372 },
  { lat: 32.8434546, lng: -117.1186447 },
  { lat: 32.8711411, lng: -117.1090315 },
  { lat: 32.8953597, lng: -117.1124647 },
];

export const orangeCountyCoords_path = [
  { lat: 33.7756917, lng: -118.124922 },
  { lat: 33.6591788, lng: -118.0741102 },
  { lat: 33.399314, lng: -117.6003248 },
  { lat: 33.6386013, lng: -117.5879652 },
  { lat: 33.8395923, lng: -117.8296644 },
  { lat: 33.9399109, lng: -117.9628737 },
  { lat: 33.7756917, lng: -118.124922 },
];

export const southSdCoords_path = [
  { lat: 32.5901899, lng: -117.1330053 },
  { lat: 32.5334761, lng: -117.1261388 },
  { lat: 32.5589439, lng: -116.8442708 },
  { lat: 32.70351, lng: -116.9836599 },
  { lat: 32.6910865, lng: -117.0066625 },
  { lat: 32.6896418, lng: -117.0173055 },
  { lat: 32.6688354, lng: -117.0423681 },
  { lat: 32.6592975, lng: -117.0722371 },
  { lat: 32.6465788, lng: -117.1165258 },
  { lat: 32.5910577, lng: -117.0969564 },
  { lat: 32.5901899, lng: -117.1330053 },
];

export const eastSdCoords_path = [
  { lat: 32.8518821, lng: -117.0310435 },
  { lat: 32.8443829, lng: -117.0090709 },
  { lat: 32.8290942, lng: -116.9970546 },
  { lat: 32.7624278, lng: -116.9987712 },
  { lat: 32.743371, lng: -117.0159373 },
  { lat: 32.7055342, lng: -117.0104441 },
  { lat: 32.7251767, lng: -116.9253001 },
  { lat: 32.8270748, lng: -116.8641887 },
  { lat: 32.8798542, lng: -116.8961177 },
  { lat: 32.8936927, lng: -116.9325099 },
  { lat: 32.8518821, lng: -117.0310435 },
];

export const downtownCoords_path = [
  { lat: 32.592506, lng: -117.1065745 },
  { lat: 32.6468699, lng: -117.1216807 },
  { lat: 32.6604557, lng: -117.0839152 },
  { lat: 32.6720165, lng: -117.0918116 },
  { lat: 32.713334, lng: -117.1031413 },
  { lat: 32.7531887, lng: -117.1292338 },
  { lat: 32.7710886, lng: -117.1330104 },
  { lat: 32.7604068, lng: -117.2054515 },
  { lat: 32.7416384, lng: -117.1810756 },
  { lat: 32.7234437, lng: -117.1958384 },
  { lat: 32.7040898, lng: -117.2284541 },
  { lat: 32.6728835, lng: -117.2160945 },
  { lat: 32.592506, lng: -117.1731791 },
  { lat: 32.5936631, lng: -117.1100077 },
  { lat: 32.592506, lng: -117.1065745 },
];

export const sdWestCoords_path = [
  { lat: 32.8754744, lng: -117.2599392 },
  { lat: 32.8746094, lng: -117.3100643 },
  { lat: 32.7958568, lng: -117.3172741 },
  { lat: 32.6609789, lng: -117.2760753 },
  { lat: 32.6511512, lng: -117.2383098 },
  { lat: 32.6693606, lng: -117.2297267 },
  { lat: 32.7057683, lng: -117.2317867 },
  { lat: 32.7418724, lng: -117.1878414 },
  { lat: 32.7568874, lng: -117.2142772 },
  { lat: 32.762373, lng: -117.2026043 },
  { lat: 32.7768072, lng: -117.1219234 },
  { lat: 32.7944138, lng: -117.1205501 },
  { lat: 32.8146137, lng: -117.1171169 },
  { lat: 32.8405784, lng: -117.1232967 },
  { lat: 32.8642285, lng: -117.1105938 },
  { lat: 32.8798883, lng: -117.110268 },
  { lat: 32.8939263, lng: -117.1191768 },
  { lat: 32.8933497, lng: -117.1356563 },
  { lat: 32.8786461, lng: -117.1638088 },
  { lat: 32.8757628, lng: -117.1837215 },
  { lat: 32.8750139, lng: -117.2302526 },
  { lat: 32.8754744, lng: -117.2599392 },
];

export const northWestCoords_path = [
  { lat: 32.8798666, lng: -117.307661 },
  { lat: 32.8769832, lng: -117.2911815 },
  { lat: 32.8775599, lng: -117.1771984 },
  { lat: 32.9127296, lng: -117.1943645 },
  { lat: 33.0406064, lng: -117.2486095 },
  { lat: 33.0423332, lng: -117.3282604 },
  { lat: 32.8798666, lng: -117.307661 },
];

export const escondidoCoords_path = [
  { lat: 33.2543133, lng: -117.2458076 },
  { lat: 33.1947331, lng: -117.2074108 },
  { lat: 33.0791634, lng: -117.2252636 },
  { lat: 33.0515422, lng: -117.2115306 },
  { lat: 33.0319719, lng: -117.0893077 },
  { lat: 33.0601748, lng: -117.0639019 },
  { lat: 33.0578728, lng: -117.0096569 },
  { lat: 33.1568017, lng: -117.0254497 },
  { lat: 33.2544706, lng: -117.1579723 },
  { lat: 33.2543133, lng: -117.2458076 },
];

export const GREEN_FROG_ZONES = {
  "La Mesa": laMesaCoords_path,
  "Poway": powayCoords_path,
  "Carlsbad": carlsbadCoords_path,
  "San Diego": sanDiegoCoords_path,
  "Orange County": orangeCountyCoords_path,
  "South SD": southSdCoords_path,
  "East SD": eastSdCoords_path,
  "Downtown": downtownCoords_path,
  "SD West": sdWestCoords_path,
  "North West": northWestCoords_path,
  "Escondido": escondidoCoords_path,
};

export const sanDiegoCoords = GREEN_FROG_ZONES['San Diego'];
export const laMesaCoords = GREEN_FROG_ZONES['La Mesa'];
export const powayCoords = GREEN_FROG_ZONES['Poway'];
export const carlsbadCoords = GREEN_FROG_ZONES['Carlsbad'];
export const orangeCountyCoords = GREEN_FROG_ZONES['Orange County'];